<template>
  <AccountAuthorizationContext context="content">
    <RouterView></RouterView>
  </AccountAuthorizationContext>
</template>

<script setup lang="ts">
import AccountAuthorizationContext from '@/components/deepadmin/account/AccountAuthorizationContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: '',
  },
})
</script>
